module.exports = "<option name=\"{%- name %}\" value=\"{%- value %}\">{%- title %}</option>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/searchDropdownOption.html
// module id = 1161
// module chunks = 1